import axios from 'axios';

export const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  // Serialize arrays as repeated query parameters without brackets.
  paramsSerializer: { indexes: null },
});

/**
 * Configure the shared Axios instance used by the generated client.
 * Call this once at app startup (e.g., after auth).
 */
export function configureClient({ baseURL, token }: { baseURL: string; token: string }) {
  axiosInstance.defaults.baseURL = baseURL;
  axiosInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
}

export function clearClientAuthorization() {
  axiosInstance.defaults.headers.common.Authorization = false;
}
